import { CheckInStatusEnum } from 'app/shared/enums/check-in-status-type.enum';
import { OrderStatusTypeEnum } from 'app/shared/enums/order-status-type.enum.model';
import { ChannelDTO } from 'app/shared/models/channel.model';
import { PointOfSaleDto } from 'app/shared/models/point-of-sale.model';
import { Shop } from 'app/shared/models/shop.model';

import { OrderTypeEnum } from '../../../../shared/enums/order-type.enum.model';
import { GridSchema } from '../common/grid-schema.model';
import { CustomerDiscountDTO, PaymentTermDto } from './customer-check-in.model';
import { OrderProductListVM } from './order-product-list.model';
import { OrderVoucherDto } from './vouchers.model';
import { OrderItem } from 'app/shared/models/order-item.model';
import { ErpServiceTypeEnum } from '../../enum/erp-service-type.enum';
import { ReOrderCartReasonEnum } from 'app/shared/enums/re-order-cart-reason.enum';
import { SeasonsReferenceDTO } from 'app/shared/models/seasons-reference.model';
import { PackageGroupModeTypeEnum } from '../../enum/package-group-mode-type.enum';
import { OrderBulkOperationsStatusDTO } from '../order/order-bulk-operations-status.model';
import { GeneralFieldsDTO } from '../customer/customer.model';
import { OrderLabelTypeEnum } from './order-label-type.enum';
import { CustomizationRequestDetailDTO } from 'app/shared/models/customization-request.models';
import { CourierDTO } from 'app/shared/models/courier.model';


export class OrderDTO {
  id: number;
  name: string;
  agencyCode: string;
  creationTime: string;
  orderStatus: OrderStatusTypeEnum;
  paymentStatus: number;
  type: OrderTypeEnum;
  note: string;
  internalNote: string;
  fullShippingAddress: string;
  fullBillingAddress: string;
  storeId: number;
  vatRate: number;
  totalWholesalePrice: number;
  discountedTotalPrice: number;
  customerId: number;
  userId: number;
  pointOfSale: PointOfSaleDto;
  pointOfSaleId: number;
  shippingLocationId: number;
  billingLocationId: number;
  manualFinancialDiscountPercentage: number;
  orderItems: OrderItem[];
  lastModificationTime: string;
  creatorId: number;
  lastModifierId: number;
  LastBusinessUserModifierId: number;
  LastBusinessUserModificationTime: string;
  deliveryDate: string;
  customerDiscount: CustomerDiscountDTO;
  agencyId: number;
  orderConfirmationDate?: string;
  appliedVouchers: OrderVoucherDto[];
  channel: ChannelDTO;
  channelId: number;
  statusDetail?: string;
  skipAutomaticDiscounts: boolean;
  skipCustomerDiscounts: boolean;
  skipStoreChannelDiscounts: boolean;
  skipVisibilityAndQuantityValidation: boolean;
  store: Shop;
  reOrderCartReason?: ReOrderCartReasonEnum;
  paymentTerm: PaymentTermDto;
  commercialAgreementId: number;
  confirmationAgencyCode: string;
  confirmationAgencyId: number;
  confirmationShippingLocationId: number;
  erpReason: string;
  erpServiceItems: OrderErpServiceItemGetDto[];
  erpDiscountedTotalPrice: number;
  hasPendingBulkOperations: boolean;
  externalId: string;
  termsOfSaleId: number;
  erpTotalRetailPrice: number;
  canProducePdfReport: boolean;
  hasPendingCartOperation: boolean;
  isGok: boolean;
  isDirect: boolean;
  seasonReferenceId: number;
  seasonReference: SeasonsReferenceDTO;
  seasonReferenceName?: string;
  packageGroupMode?: PackageGroupModeTypeEnum;
  courierId?: number;
  courier?: CourierDTO;
  cancellationReason?: GeneralFieldsDTO;
  orderLabelId?: OrderLabelTypeEnum;
  centralPaymentNumberFullName?: string;
  invoicingNumberFullName?: string;
  invoicingParentCustomerId?: number;
  customizationRequestId?: number;
  shouldRenderVat?: boolean;
  vatMarkupPercentage?: number;
  totalWithVat: number;

  constructor(init?: OrderDTO) {
    Object.assign(this, init);
  }
}
export class OrderVM extends OrderDTO {
  totalRetailPrice: number;
  posName: string;
  customerName: string;
  channelName: string;
  channelSupportStockLimit?: boolean;
  orderQty: number;
  isConfirmed: boolean;
  totalDiscountPerc: number;
  totalWholeSale: number;
  checked: boolean;
  isEditable: boolean;

  constructor(init?: OrderVM) {
    super();
    Object.assign(this, init);
  }
}

export class OrderAssortmentGraphDTO {
  quantity: number;
  value: number;
  assortmentName: string;
  assortmentId: number;

  constructor(init?: Partial<OrderAssortmentGraphDTO>) {
    Object.assign(this, init);
  }
}

export class OrderErpServiceItemGetDto {
  id?: number;
  erpDiscountedTotalPrice: number;
  erpServiceId?: number;
  orderId?: number;
  erpService: OrderErpServiceGetDto;
  constructor(init?: OrderErpServiceItemGetDto) {
    Object.assign(this, init);
  }
}

export class OrderErpServiceUpdateDto {
  erpDiscountedTotalPrice: number;
  constructor(init?: OrderErpServiceUpdateDto) {
    Object.assign(this, init);
  }
}

export class OrderErpServiceInsertDto extends OrderErpServiceUpdateDto {
  serviceExternalId: string;
  constructor(init?: OrderErpServiceInsertDto) {
    super();
    Object.assign(this, init);
  }
}


export class OrderErpServiceGetDto {
  id?: number;
  externalId: string;
  name?: string;
  storeId?: number;
  isSystem?: boolean;
  erpServiceType: ErpServiceTypeEnum;
  constructor(init?: OrderErpServiceGetDto) {
    Object.assign(this, init);
  }
}

export interface GridOrderSchema<T> extends GridSchema<T> {
  visibilityType: number;
  areFiltered?: boolean;
  agencyId?: number;
  customerId?: number;
  pointOfSaleId?: number;
  onlineStore?: number;
  orderStatus?: OrderStatusTypeEnum[];
  hasNotes?: boolean;
  externalOrderId?: string;
  channelId?: number;
  seasonReferenceId?: number;
  voucherId?: number;
  showOnlyWithCr?: boolean;
  orderLabelId?: OrderLabelTypeEnum;
};

export interface IOrderGrid {
  dataset?: OrderVM[],
  dataToView?: OrderVM[],
  filteredLength?: number,
  search?: string,
  loaderId?: string,
  size?: number,
  page?: number,
  checkedAll?: boolean,

};

export interface IOrderProductGrid {
  dataset?: OrderProductListVM[];
  dataToView?: OrderProductListVM[];
  filteredLength?: number;
  search?: string;
  loaderId?: string;
  checkedAll?: boolean;
  page?: number;
  size?: number;
  filteredData?: OrderProductListVM[];
}

export interface OrderErrorMessage {
  code: string;
  message: string;
}

export interface OrderImportReportDto {
  order: OrderDTO;
  reportList: OrderErrorMessage[];
}

export interface OrderDetailInfo {
  customerName: string;
  customerLocation: string;
  posName: string;
  posLocation: string;
  shipAddressLocation: string;
  agentName: string;
  agentEmail: string;
  userName: string;
  userEmail: string;
  agencyCode: string;
  agencyName: string;
  storeName: string;
  posStatus: CheckInStatusEnum;
  customerStatus: CheckInStatusEnum;
  paymentTerm: PaymentTermDto;
  isCustomerCommercialBlocked: boolean;
  confirmationAgencyCode: string;
  confirmationAgencyName: string;
  confirmationAgencyId: number;
  confirmationShippingLocationId: number;
  confirmationShipAddressLocation: string;
  externalId: string;
  bulkOperationsStatus: OrderBulkOperationsStatusDTO;
  cancellationReason: GeneralFieldsDTO;
  invoicingNumberFullName?: string;
  centralPaymentNumberFullName?: string;
  crDetails?: CustomizationRequestDetailDTO;
  invoicingParentCustomerId?: number;
  centralPaymentParentCustomerId?: number;
}

export class OrderDeliveryDate {
  deliveryDate: string;
  count: number;
  isCustom: boolean;
  data: OrderProductListVM[];

  constructor(init?: OrderDeliveryDate) {
    Object.assign(this, init);
  }
}

export class OrderTypeData {
  id: OrderTypeEnum;
  name: string;
  constructor(init?: OrderTypeData) {
    Object.assign(this, init);
  }
}

export class OrderStatDTO {
  date: string;
  confirmedOrdersCount: number;
  confirmedOrdersTotalMargin: number;
  confirmedOrdersTotalWithDiscounts: number;
  confirmedOrdersTotalWithoutDiscounts: number;
  createdOrdersCount: number;
  draftOrdersCount: number;
}
